export enum LabelType {
	Default = 'default',
	Large = 'large',
	Heading = 'heading',
}
